import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center font-black gap-10 bg-wrh-blue-200" }

import { computed } from 'vue';
import store from '@/store';
import { endImpersonationSession } from '@/util/funcs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const impersonatedBuyer = computed(() => `${store.getters.homebuyer.firstName} ${store.getters.homebuyer.lastName}`);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("p", null, "Logged in as: " + _toDisplayString(_unref(impersonatedBuyer)), 1),
    _createElementVNode("p", {
      class: "underline text-blue-600 cursor-pointer",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(endImpersonationSession) && _unref(endImpersonationSession)(...args)))
    }, "Exit View")
  ]))
}
}

})